var _line, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1154,
    height: 185,
    viewBox: "0 0 1154 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 184.5,
    x2: 927,
    y2: 184.5,
    stroke: "#1CF8BD",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M927 184.5L934 180.5H938.5L944.5 177H948L952 171.5H957L960.5 166.5L972 169L980.5 164.5L991 65C990.167 64.1667 988.5 61.9 988.5 59.5C988.5 57.1 988.5 53.5 988.5 52C989.667 51.3333 992.5 50 994.5 50V46C993.833 45.8333 992.5 45.2 992.5 44C992.5 42.8 992.5 39.8333 992.5 38.5C993 38.1667 994.3 37.5 995.5 37.5V29C997.5 26.8333 1002.2 22.3 1005 21.5L1006.5 1V21.5C1009.33 22.8333 1015.4 26.4 1017 30V37.5C1017.67 37.6667 1019 38.5 1019 40.5C1019 42.5 1019 44 1019 44.5L1018 46V50.5L1024 53.5V60.5C1023.67 61.3333 1022.5 63.1 1020.5 63.5L1030 154C1033.83 153.667 1042.3 154.6 1045.5 161C1047.67 160 1053.2 160 1058 168C1060.83 168 1067.2 169.2 1070 174L1078.5 184.5",
    stroke: "#15454F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M996 99V107.5H1001V99H996Z",
    stroke: "#15454F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M997.5 68.5V62H1001V68.5H997.5Z",
    stroke: "#15454F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M996 37.5002C997.5 37.5002 1009.5 35.5002 1016.5 37.5002M994.5 45.0002C999.333 43.6669 1010.8 41.8002 1018 45.0002M994.5 50.0002C999.667 49.6669 1011.6 49.2002 1018 50.0002M989.5 61.0002C991 60.5002 998.5 53.0002 1023.5 60.0002",
    stroke: "#15454F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M984 137.5C990.667 135.166 1008.8 131.9 1028 137.5M986.5 115C991.5 112.833 1006.2 109.8 1025 115M988.5 91.9995C995.833 90.4995 1013.1 88.4995 1023.5 92.4995M991 72.4997C995.5 70.9997 1007.9 68.8997 1021.5 72.4997M996 28.4997C1000.5 27.4997 1011 26.2997 1017 29.4997M981.5 165L992 162.5H1001.5L1018 152.5L1025 156L1032 154",
    stroke: "#15454F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1078 184.5H1154",
    stroke: "#1CF8BD",
    strokeOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlFooter);
export default __webpack_public_path__ + "static/media/il_footer.28ef12c7dc812dd689abae3f11c2fff0.svg";
export { ForwardRef as ReactComponent };